import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Fade } from '@mui/material';
import MaterialDialogContent from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogContent';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import IslandIcon from 'Icons/IslandIcon';
import DateRangePicker from './DateRangePicker';
import MessageEditor from './MessageEditor';
import ConflictingScheduledMessages from './ConflictingScheduledMessages';
import OutOfOfficeAlertMessage from './AlertMessage';

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.facet.lightGray,
    padding: 0,
    maxWidth: 775,
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(4),
    minWidth: '100%',
    backgroundColor: theme.palette.common.white,
    marginBottom: theme.spacing(2),
  },
  headerTitle: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: theme.spacing(2),
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: '1.8em',
  },
  islandIcon: {
    marginRight: theme.spacing(1),
    color: theme.palette.facet.primaryBlue,
    fontSize: '2em',
  },
});

const OutOfOfficeDialogContent = ({
  className,
  classes,
  ...rest
}) => {
  return (
    <MaterialDialogContent
      className={classNames(classes.root, className)}
      disableTypography
    >
      <Fade in>
        <div>
          <div className={classes.header}>
            <div className={classes.headerTitle}>
              <IslandIcon
                className={classes.islandIcon}
              />
              <Typography
                className={classes.title}
                color="primary"
                align="left"
                variant="h2"
              >
                {'Out of Office'}
              </Typography>
            </div>
            <OutOfOfficeAlertMessage {...rest} />
          </div>
          <div>
            <DateRangePicker {...rest} />
            <MessageEditor {...rest} />
            <ConflictingScheduledMessages {...rest} />
          </div>
        </div>
      </Fade>
    </MaterialDialogContent>
  );
};

OutOfOfficeDialogContent.defaultProps = {
  className: '',
};

OutOfOfficeDialogContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(OutOfOfficeDialogContent);
